import { customFetch } from '../../../../shared/customFetch';
import { API_ROUTES } from '../../../shared/ApiRoutes';

export const getPartenaires = () => {
  return customFetch.get(API_ROUTES.GESTION.PARTENAIRE.BASE);
};

export const getCustomPartenaires = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.PARTENAIRE.ADMIN_CUSTOM(userId));
};

export const createPartenaire = (part: any) => {
  return customFetch.post(API_ROUTES.GESTION.PARTENAIRE.BASE, part);
};

export const getAgences = () => {
  return customFetch.get(API_ROUTES.GESTION.AGENCE.BASE);
};

export const getCustomAgences = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.AGENCE.ADMIN_CUSTOM(userId));
};

export const createAgence = (age: any) => {
  return customFetch.post(API_ROUTES.GESTION.AGENCE.BASE, age);
};

export const getUtilisateurs = () => {
  return customFetch.get(API_ROUTES.UTILISATEUR.BASE);
};

export const getCustomUtilisateurs = (userId: string) => {
  return customFetch.get(API_ROUTES.UTILISATEUR.ADMIN_CUSTOM(userId));
};

export const getUtilisateurDetails = (connectedUserId: string) => {
  return customFetch.get(API_ROUTES.UTILISATEUR.DETAILS(connectedUserId));
};

export const verouillerCompte = (url: string) => {
  return customFetch.patch(url, { actif: false });
};

export const deverouillerCompte = (url: string) => {
  return customFetch.patch(url, { actif: true });
};

export const updatePassword = (url: string, password: string) => {
  return customFetch.patch(url, { password });
};

export const createUtilisateur = (data: any) => {
  return customFetch.post(API_ROUTES.UTILISATEUR.BASE, data);
};

export const updateUtilisateur = (url: string, data: any) => {
  return customFetch.patch(url, data);
};

export const getUtilisateursProfils = (connectedUserId: string) => {
  return customFetch.get(API_ROUTES.UTILISATEUR.PROFIL(connectedUserId));
};

export const createUtilisateurProfil = (data: any) => {
  return customFetch.post(API_ROUTES.GESTION.PROFIL.USER_PROFIL, data);
};

export const deleteUtilisateurProfil = (data: any) => {
  return customFetch.post(API_ROUTES.GESTION.PROFIL.DELETE_PROFIL, data);
};

export const getProfils = () => {
  return customFetch.get(API_ROUTES.GESTION.PROFIL.BASE);
};

export const getOperationReporting = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.REPORTING.OPERATION(userId));
};
